import React from 'react';

export default function Lock() {
  return (
    <svg
      version="1.1"
      x="0px"
      y="0px"
      viewBox="0 0 448 448"
      width="24px"
      height="21px"
      enableBackground="new 0 0 448 448">
      <g>
        <g>
          <g fill="#80868b">
            <path
              d="M352,149.333h-21.333v-42.667C330.667,47.787,282.88,0,224,0S117.333,47.787,117.333,106.667h40.533
                            c0-36.48,29.653-66.133,66.133-66.133s66.133,29.653,66.133,66.133v42.667H96c-23.573,0-42.667,19.093-42.667,42.667v213.333
                            C53.333,428.907,72.427,448,96,448h256c23.573,0,42.667-19.093,42.667-42.667V192C394.667,168.427,375.573,149.333,352,149.333z
                            M352,405.333H96V192h256V405.333z"
            />
            <path
              d="M224,341.333c23.573,0,42.667-19.093,42.667-42.667C266.667,275.093,247.573,256,224,256s-42.667,19.093-42.667,42.667
                            C181.333,322.24,200.427,341.333,224,341.333z"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}
